<script>
export default {
    name: "PatientDetailsTemplate",

    data() {

        return {
            showDetails: true
        }
    },

    props: {
        patient: Object,
    },
}
</script>
<template>
    <div class=" border-2 border-gray-500 p-1">
        <div class="flex md:flex-row sm:flex-col border bg-indigo-400 cursor-pointer" @click.prevent="showDetails = !showDetails">
            <div class="md:w-1/6 sm:w-full p-1">
                <h5 class="text-sm"><span class="font-bold">Visit No: </span><span class="text-xs font-semibold">{{ patient.visitNo }}</span> </h5>
            </div>
            <div class="md:w-1/4 sm:w-full p-1">
                <h5 class="text-sm"><span class="font-bold">Patient Name: </span><span class="text-xs font-semibold">{{ patient.names }}</span></h5>
            </div>
            <div class="md:w-1/5 sm:w-full p-1">
                <h5 class="text-sm"><span class="font-bold">Reg On: </span><span class="text-xs font-semibold">{{ patient.regdate | dateFormat }}</span></h5>
            </div>
            <div class="md:w-1/5 sm:w-full p-1">
                <h5 class="text-sm"> <span class="font-bold">Payment Mode:</span><span class="text-xs font-semibold">{{ patient.pMode }}</span></h5>
            </div>
            <div class="md:w-1/6 sm:w-full p-1">
                <h5 class="text-sm"><span class="font-bold"></span>IP File No: <span class="text-xs font-semibold">{{ patient.ipfileno }}</span></h5>
            </div>
            <div class="md:w-1/6 sm:w-full p-1">
                <h5 class="text-sm"><span class="font-bold">OP File No: </span><span class="text-xs font-semibold">{{ patient.opfileno }}</span></h5>
            </div>
            <div class="w-12 p-1 text-right">
                <i :class="`text-blue-900 fa fa-caret-${showDetails ? 'right' : 'down'}`"></i>
            </div>
        </div>
        <div class="flex flex-wrap" v-show="showDetails">
            <div class="md:w-1/4 sm:w-full p-2">
                <h5 class="text-sm font-bold">Ward:<span class="text-indigo-600"></span></h5>
            </div>
            <div class="md:w-1/4 sm:w-full p-2">
                <h5 class="text-sm font-bold">Blood group: <span class="text-indigo-600"></span></h5>
            </div>
            <div class="md:w-1/4 sm:w-full p-2">
                <h5 class="text-sm font-bold">Age: <span class="text-indigo-600"></span></h5>
            </div>
            <div class="md:w-1/4 sm:w-full p-2">
                <h5 class="text-sm font-bold">Bed: <span class="text-indigo-600"></span></h5>
            </div>
            <div class="md:w-1/4 sm:w-full p-2">
                <h5 class="text-sm font-bold">Gender: <span class="text-indigo-600">{{ patient.gender }}</span></h5>
            </div>
            <div class="md:w-1/4 sm:w-full p-2">
                <h5 class="text-sm font-bold">Telephone: <span class="text-indigo-600">{{ patient.homE_PHONE }}</span></h5>
            </div>
            <div class="md:w-1/4 sm:w-full p-2">
                <h5 class="text-sm font-bold">Date registered: <span class="text-indigo-600">{{ patient.regdate | dateFormat }}</span></h5>
            </div>
            <div class="md:w-1/4 sm:w-full p-2">
                <h5 class="text-sm font-bold">ID Number: <span class="text-indigo-600">{{ patient.nationalid }}</span></h5>
            </div>
            <div class="md:w-1/4 sm:w-full p-2">
                <h5 class="text-sm font-bold">Status: <span class="text-indigo-600">{{ patient.isalive }}</span></h5>
            </div>
            <div class="md:w-1/4 sm:w-full p-2">
                <h5 class="text-sm font-bold">Physical: <span class="text-indigo-600"></span></h5>
            </div>
            <div class="md:w-1/4 sm:w-full p-2">
                <h5 class="text-sm font-bold">Active: <span class="text-indigo-600">{{ patient.active }}</span></h5>
            </div>
            <div class="md:w-1/4 sm:w-full p-2">
                <h5 class="text-sm font-bold">Marital Status: <span class="text-indigo-600">{{ patient.maritalStatus }}</span></h5>
            </div>
        </div>
        
    </div>
</template>
